import TagTypeItem, { TagTypeItemProps } from './TagTypeItem';

export type { TagTypeItemProps };
export default TagTypeItem;
